<template>
  <div>
    <div class="modal" :class="{'is-active': active}">
      <div class="modal-background" @click.prevent.stop="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">FICHIER EXPORT GED</p>
          <button aria-label="close" class="delete" @click.prevent.stop="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns has-bg-warning">
            <div class="column ">
              AU CLIC SUR "ENVOYER FICHIER", LE FICHIER SERA DIRECTEMENT COMMUNIQUÉ PAR MAIL AU<span v-if="gedContacts && gedContacts.length > 1">X</span> DESTINATAIRE<span v-if="gedContacts && gedContacts.length > 1">S</span>
              ({{gedContacts}})
            </div>
          </div>
          <div class="columns">
            <div class="column has-text-centered">
              <button @click="downloadGedFile" class="button is-success">
                <span>Télécharger fichier</span>
                <span class="icon is-small">
                  <i class="fal fa-download"></i>
                </span>
              </button>
              <button v-if="isSending" class="button is-success is-loading">
              </button>
              <button v-else @click="sendGedExport" class="button is-success">
                <span>Envoyer fichier</span>
                <span class="icon is-small">
                  <i class="fal fa-paper-plane"></i>
                </span>
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import { downloadURI } from '../../utils'
  import { mapState } from 'vuex'

  export default {
    name: 'GedExportModal',
    props: {
      active: Boolean
    },
    data () {
      return {
        isSending: false
      }
    },
    computed: {
      ...mapState(['configs']),
      gedContacts () {
        let contacts = this.configs.GED_CONTACTS
        contacts = contacts.split(';')
        return contacts.join(', ')
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      downloadGedFile () {
        const apiRoot = this.$configs.APIROOT
        const url = `${apiRoot}/export/ged?mode=download`
        downloadURI(url, 'export-ged.xlsx')
      },
      async sendGedExport () {
        this.isSending = true
        console.log('send ged export')
        const apiRoot = this.$configs.APIROOT
        const url = `${apiRoot}/export/ged?mode=send`
        let success = false
        try {
          await this.$api.axios.get(url)
          success = true
        } catch (e) {
          console.log('erreur')
        } finally {
          this.isSending = false
        }

        if (success) {
          this.$notify({
            type: 'is-success',
            text: `Le fichier ged a bien été envoyé.`
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/adv/GedExportModal.vue